import { Component } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { emailValidator } from 'src/app/shared/validators/email.validator';

@Component({
  standalone: false,
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html'
})
export class ConfirmDialogComponent {
  message = '';
  confirmLabel = 'Confirm';
  cancelLabel = 'Cancel';
  showInput = false;
  inputPlaceholder = '';
  inputValue = '';
  inputTouched = false;
  header = '';

  /**
   * @description Checks if the input value is a valid email
   * @returns {boolean} boolean
   */
  get isEmailValid(): boolean {
    if (!this.inputValue?.trim()) {
      return false;
    }
    const validator = emailValidator();
    return !validator({ value: this.inputValue } as AbstractControl);
  }

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    if (config.data) {
      this.header = config.data.header || '';
      this.message = config.data.message || this.message;
      this.confirmLabel = config.data.confirmLabel || this.confirmLabel;
      this.cancelLabel = config.data.cancelLabel || this.cancelLabel;
      this.showInput = config.data.showInput || false;
      this.inputPlaceholder = config.data.inputPlaceholder || '';
    }
  }


  /**
   * @description Sets the inputTouched to true when the input is blurred
   * @returns {void} void
   */
  onInputBlur(): void {
    this.inputTouched = true;
  }

  /**
   * @description Closes the dialog with the input value if the input is valid
   * @returns {void} void
   */
  confirm(): void {
    if (this.showInput && !this.isEmailValid) {
      this.inputTouched = true;
      return;
    }
    this.ref.close(this.showInput ? this.inputValue : true);
  }

  /**
   * @description Closes the dialog with false
   * @returns {void} void
   */
  cancel(): void {
    this.ref.close(false);
  }
}
